module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_3.28bd3d22.png";